export const RedirectedPaths = {
  '/search-referals': '/',
  'student-enquiries': '/tutor/orders',
  '/registration': '/signin',
  '/tutor/index': '/',
  '/tutor-registration': '/signin',
};

export const STATUSES = {
  approved: 'مقبول',
  pending: 'قيد الإنتظار',
  canceled: 'ملغي ',
  running: 'جاري ',
  closed: 'مغلق',
  completed: 'مكتمل',
  cancelled_before_course_started: 'ملغي قبل بدء الجلسه',
  cancelled_after_course_completed: 'ملغي بعد انتهاء الجلسه',
  cancelled_when_course_running: 'ملغي  اثناء الجلسه',
};

export const COLORS = {
  approved: '#3CB965',
  pending: '#DAB028',
  canceled: '#FF3B30',
  running: '#3CB965',
  closed: '#777676',
  completed: '#3CB965',
  cancelled_before_course_started: '#FF3B30',
  cancelled_after_course_completed: '#FF3B30',
  cancelled_when_course_running: '#FF3B30',
};

export const MOBILE_STATUSES = {
  pending: 'قيد الإنتظار',
  on_going: 'On going',
  approved: 'مقبول',
  cancel: 'ملغي',
  cancelled: 'ملغي',
  running: 'جاري',
  session_initiated: 'الساعة التجريبية',
  completed: 'مكتمل',
  repeated: 'مكرر',
  assigned_related: 'طلب مشابه',
  find_tutor: 'البحث عن معلم',
  called_for_admin_intervention: 'اتصلت لتدخل الإدارة',
  assigned_to_another: 'التحويل لمعلم إ',
  closed: 'مغلق',
};
export const MOBILE_STATUSES_COLORS = {
  pending: '#EAA440',
  on_going: '#EAA440',
  approved: '#4D9838',
  cancel: '#D33631',
  running: '#5C79F4',
  session_initiated: '#5C79F4',
  completed: '#4D9838',
  repeated: '#253cef',
  assigned_related: '#CCCCCC',
  find_tutor: '#EAA440',
  called_for_admin_intervention: '#EAA440',
  assigned_to_another: '#EAA440',
  closed: '#343637',
};

export const BACKGROUND_COLORS = {
  approved: 'rgb(60 185 101 / 36%)',
  pending: 'rgb(218 176 40 / 30%)',
  canceled: 'rgb(255 59 48 / 20%)',
  running: 'rgb(60 185 101 / 36%)',
  closed: 'rgb(221 217 217 / 0%)',
  completed: 'rgb(60 185 101 / 36%)',
  cancelled_before_course_started: 'rgb(255 59 48 / 20%)',
  cancelled_after_course_completed: 'rgb(255 59 48 / 20%)',
  cancelled_when_course_running: 'rgb(255 59 48 / 20%)',
};

export  const MOBILE_BACKGROUND_COLORS = {
  pending: '#DAB028',
  on_going: '#EAA440',
  approved: '#3CB965',
  cancel: '#FF3B30',
  running: '#3CB965',
  session_initiated: '#5C79F4',
  completed: '#3CB965',
  repeated: '#253cef',
  assigned_related: '#CCCCCC',
  find_tutor: '#DAB028',
  called_for_admin_intervention: '#EAA440',
  assigned_to_another: '#EAA440',
  closed: '#DDD9D9',
};


export const TRAINING_SUBJECT_ID = 151;
 